import { Component, Vue } from 'vue-property-decorator';
import WithRender from './relayedsms.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';

@WithRender
@Component({
  filters: {
    formateDate(value: string) {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
  components: {
    Loading,
  }
})
export default class RelayedSms extends Vue {
  isLoading = false;
  busy = false;
  processing = false;
  pendingItem: any = null;
  flaggedOnly = false;

  perPage = 100;
  currentPage = 1;
  selectedPage = 1;
  totalRecords = 0;

  items = [];
  fields = [
    {
      key: "sender",
      label: "Sender",
      sortable: false,
    },
    {
      key: "message",
      label: "Message",
      sortable: false,
    },
    {
      key: "deposit",
      label: "Deposit",
      sortable: false,
    },
    {
      key: "reference",
      label: "Reference",
      sortable: false,
    },
    {
      key: "match",
      label: "Match",
      sortable: false,
    },
    {
      key: "agentCode",
      label: "Agent Code",
      sortable: false,
    },
    {
      key: "depositRequestedOn",
      label: "Deposit Requested",
      sortable: false,
    },
    {
      key: "receivedAt",
      label: "Received On (device)",
      sortable: false,
    },
    {
      key: "createdOn",
      label: "Relayed On",
      sortable: false,
    },
    {
      key: "action",
      label: "",
      sortable: false,
    }
  ]

  mounted() {
    this.getMessages();
  }

  onAcknowledgeClick(item: any) {
    this.pendingItem = item;
    this.busy = true;
  }

  onCancel() {
    this.busy = false;
    this.processing = false;
    this.pendingItem = null;
  }

  onOK() {
    this.processing = true;
    this.acknowledge();
  }

  acknowledge(): void {
    const item = this.pendingItem;
    _axios.post(`${config.gateway}relay/messages/${item.id}/acknowledge`)
      .then(() => {
        this.items = this.items.filter((x: any) => x.id !== item.id);
        this.totalRecords -= 1;
      })
      .catch(err => {
        console.error(err);
        const status = (err.response && err.response.status) || '';
        const detail = (err.response && err.response.data) || err.message || '';
        alert(`Could not acknowledge message: ${status} ${detail}`);
      })
      .finally(() => {
        this.busy = false;
        this.processing = false;
        this.pendingItem = null;
      });
  }

  handlePageClick() {
    if (this.currentPage === this.selectedPage)
      return;
    this.currentPage = this.selectedPage;
    this.getMessages();
  }

  onFilterChange() {
    this.currentPage = 1;
    this.selectedPage = 1;
    this.getMessages();
  }

  onReprocessClick() {
    if (!window.confirm("Re-run deposit matching against stored messages that haven't been recognised yet? This can take a while."))
      return;

    this.isLoading = true;
    _axios.post(`${config.gateway}relay/messages/reprocess`)
      .then(response => {
        const { considered, recognisedAsDeposits } = response.data;
        alert(`Reprocessed ${considered} message(s), ${recognisedAsDeposits} recognised as deposits.`);
        this.getMessages();
      })
      .catch(err => {
        console.error(err);
        const status = (err.response && err.response.status) || '';
        const detail = (err.response && err.response.data) || err.message || '';
        alert(`Could not reprocess messages: ${status} ${detail}`);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  getMessages(): void {
    this.isLoading = true;
    _axios.get(`${config.gateway}relay/messages?currentPage=${this.currentPage}&pageSize=${this.perPage}&flaggedOnly=${this.flaggedOnly}`)
      .then(response => {
        this.items = response.data.objectList;
        this.totalRecords = response.data.totalRowCount;
      })
      .catch(err => {
        console.error(err);
        const status = (err.response && err.response.status) || '';
        const detail = (err.response && err.response.data) || err.message || '';
        alert(`Could not load relayed SMS: ${status} ${detail}`);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
